import ReactECharts from "echarts-for-react";
import { useContext, useEffect, useState } from "react";
import { DashboardContext } from "states/DashboardContext";

function ShuleMisingiKwaMikoa() {
  const hook = useShuleMisingiKwaMikoa();
  const words = useTranslations();

  const options = {
    title: {
      text: `${words.chartTitle}`,
      textStyle: {
        fontSize: "20",
      },
    },
    maintainAspectRatio: false,
    grid: {
      containLabel: true,
      left: "9%",
      bottom: "0%",
      right: "5%",
      top: "10%",
    },
    tooltip: { trigger: "axis" },
    toolbox: {
      show: true,
      feature: {
        dataView: { show: true, readOnly: false },
        magicType: { show: true, type: ["line", "bar"] },
        restore: { show: true },
        saveAsImage: { show: true },
      },
    },
    dataZoom: [
      { show: false },
      { type: "inside" },
      {
        show: false,
        yAxisIndex: 10,
        filterMode: "empty",
        width: 30,
        height: "70%",
        showDataShadow: false,
        left: "93%",
      },
    ],
    xAxis: {
      type: "category",
      data: ((regions) => {
        const dt = regions.map((region) => {
          return region.name;
        });
        return dt;
      })(hook.regionData),
      axisLabel: {
        show: true,
        interval: 0,
        rotate: 90,
        fontSize: "16",
        fontWeight: "bold",
      },
    },
    yAxis: [
      {
        type: "value",
        nameLocation: "middle",
        nameGap: 50,
        axisLabel: {
          formatter: "{value}",
          show: true,
          interval: 0,
          rotate: 0,
          fontSize: "16",
          fontWeight: "800",
        },
      },
    ],
    series: [
      {
        type: "bar",
        name: "",
        barMaxWidth: 20,
        data: ((regions) => {
          const regionCounts = regions.map((region) => region.value);
          const dt = regionCounts.map((count, index) => {
            return {
              value: count,
              itemStyle: {
                color: "#1985A1",
              },
            };
          });
          return dt;
        })(hook.regionData),
      },
    ],
  };
  return (
    <div className="h-full text-[1.5vw] flex items-center justify-center">
      <div className="relative flex flex-col items-center justify-center w-full h-full gap-2">
        {hook.regionData && (
          <ReactECharts
            style={{ height: "60vh", minHeight: 200, width: "100%" }}
            option={options}
          />
        )}
      </div>
    </div>
  );
}

export default ShuleMisingiKwaMikoa;

const useTranslations = () => {
  const { languageState } = useContext(DashboardContext);
  const [language] = languageState;

  return {
    chartTitle: language
      ? "Number of Primary Schools by region"
      : "Idadi ya Shule za Msingi kwa Mikoa",
    chartYAxis: language ? "Number in 100,000" : "Idadi kwa 100,000",
    language,
  };
};

const useShuleMisingiKwaMikoa = () => {
  const censusYears = [1967, 1978, 1988, 2002, 2012, 2022];
  const lastIndex = censusYears.length - 1;
  const [selectedYearIndex, setSelectedYearIndex] = useState(lastIndex);
  const censusYear = censusYears[selectedYearIndex];
  const previousCensusYear = censusYears[selectedYearIndex - 1] ?? null;
  const nextCensusYear = censusYears[selectedYearIndex + 1] ?? null;

  // year change handlers
  const handleNext = () => {
    if (selectedYearIndex === lastIndex) return;
    setSelectedYearIndex((prev) => prev + 1);
  };

  const handlePrevious = () => {
    if (selectedYearIndex === 0) return;
    setSelectedYearIndex((prev) => prev - 1);
  };

  const [data, setData] = useState([]);

  useEffect(() => {
    const _data = regionDataGenerator(censusYear);
    setData((prev) => {
      prev = _data;
      return prev;
    });
  }, [selectedYearIndex]);

  return {
    regionData: data,
    selectedYearIndex,
    lastIndex,
    handleNext,
    handlePrevious,
    censusYear,
    previousCensusYear,
    nextCensusYear,
  };
};

const regionDataGenerator = (year) => {
  return [
    { name: "Dodoma", value: 827 },
    { name: "Arusha", value: 833  },
    { name: "Kilimanjaro", value: 999 },
    { name: "Tanga", value: 1083  },
    { name: "Morogoro", value: 996 },
    { name: "Pwani", value: 713 },
    { name: "Dar es Salaam", value: 838 },
    { name: "Lindi", value: 530 },
    { name: "Mtwara", value: 692 },
    { name: "Ruvuma", value: 829 },
    { name: "Iringa", value: 544 },
    { name: "Mbeya", value: 807 },
    { name: "Singida", value: 630 },
    { name: "Tabora", value: 875 },
    { name: "Rukwa", value: 394 },
    { name: "Kigoma", value: 701 },
    { name: "Shinyanga", value: 671 },
    { name: "Kagera", value: 1026 },
    { name: "Mwanza", value: 1038 },
    { name: "Mara", value: 908 },
    { name: "Manyara", value: 692 },
    { name: "Njombe", value: 544 },
    { name: "Katavi", value: 266 },
    { name: "Simiyu", value: 592 },
    { name: "Geita", value: 742 },
    { name: "Songwe", value: 496},
    { name: "Kaskazini Unguja", value: 67 },
    { name: "Kusini Unguja", value: 72 },
    { name: "Mjini Magharibi", value: 226 },
    { name: "Kaskazini Pemba", value: 67 },
    { name: "Kusini Pemba", value: 71 },
  ].sort((a, b) => (a.value < b.value ? 1 : -1));
};
